import React, { FC, useMemo } from 'react'
import ReportSummaryModule from './ReportSummaryModule'
import Loading from '../common/Loading'
import { secToHour } from '../../../utils/date'
import InfoTips from '../common/InfoTips'

interface Props {
  member: MemberDetail | undefined
}

interface MemberDetail {
  id: number
  name: string
  profile_image_url?: string | null
  label_groups: ListDetail[]
  labels: ListDetail[]
}

interface ListDetail {
  id: number
  name: string
  code: string | null
  color: string
  time: number
}

const MemberSummaryModule: FC<Props> = (props) => {
  const {
    member,
  } = props

  const calcList = (list: ListDetail[]) => {
    let tmpList: { id: number; name: string; color: string; time: number; cost: number }[] = []
    list.forEach((v) => {
      if (!tmpList.map((w) => w.name).includes(v.name)) {
        tmpList.push({
          id: v.id,
          name: v.name,
          color: v.color,
          time: v.time,
          cost: 0,
        })
      } else {
        tmpList = tmpList.map((w) => {
          if (w.name === v.name) return { ...w, time: w.time + v.time }
          return w
        })
      }
    })
    return tmpList
  }

  const labelGroupList = useMemo(() => {
    if (!member) return []
    return calcList(member.label_groups)
  }, [member])

  const labelList = useMemo(() => {
    if (!member) return []
    return calcList(member.labels)
  }, [member])

  const maxTime = useMemo(() => {
    if (!member) return 0
    const tmpMax = member.labels.reduce((s, w) => s + w.time, 0)
    return (secToHour(tmpMax) + 1) * 3600
  }, [member])

  return (
    <>
      <div className="summary_title">
        工数管理情報
      </div>
      <InfoTips>
        <>
          <div>
            工数管理機能で仕分けされた時間を集計しています
          </div>
          <div>
            それぞれプロジェクト別・業務別の割合と時間を表示しています
          </div>
        </>
      </InfoTips>
      {
        member ? (
          <>
            {
              maxTime > 3600 ? (
                <>
                  <div className="category_title_area">
                    <div className="category_title">
                      プロジェクト別仕分け実績情報
                    </div>
                  </div>
                  <ReportSummaryModule
                    list={labelGroupList}
                    type="time"
                    graphTitle="プロジェクト別仕分け実績情報"
                    headerTitle="プロジェクト(実績時間が多い順)"
                    chartSize={300}
                  />
                  <div className="category_title_area">
                    <div className="category_title">
                      業務別仕分け実績情報
                    </div>
                  </div>
                  <ReportSummaryModule
                    list={labelList}
                    type="time"
                    graphTitle="業務別仕分け実績情報"
                    headerTitle="業務(実績時間が多い順)"
                    chartSize={300}
                  />
                </>
              ) : (
                <>
                  <div>
                    <div
                      style={{
                        marginBottom: "24px",
                        padding: "0 24px",
                        fontSize: "14px",
                      }}
                    >
                      <p>
                        工数管理機能を使って業務仕分けをおこなうと、より詳細な分析情報が表示できます。
                      </p>
                      <p>
                        工数管理機能の使い方は
                        <a href="https://qasee.zendesk.com/hc/ja/articles/43881715166617" target="_blank" rel="noreferrer">
                          こちら
                        </a>
                        をご覧ください。
                      </p>
                      <p>
                        是非、ご活用ください。
                      </p>
                    </div>
                    <img
                      className="no_use"
                      src="/static/images/task/image_8.png"
                      alt="工数管理を利用すれば、さらにわかる"
                      style={{
                        width: "100%",
                      }}
                    />
                  </div>
                </>
              )
            }
          </>
        ) : (
          <>
            <Loading />
          </>
        )
      }
    </>
  )
}

export default MemberSummaryModule
